import ClaimListing, {
  ClaimColumns,
  ClaimFilters,
  ClaimStatusFilter_ApprovedOrAttached,
} from '../shared/ClaimListing/ClaimListing';

export default function FinalReviewTab() {
  return (
    <ClaimListing
      columns={[
        ClaimColumns.claimAttachedDate,
        ClaimColumns.insuredName,
        ClaimColumns.reinsuranceYear,
        ClaimColumns.policyNumber,
        ClaimColumns.sce,
        ClaimColumns.status,
        ClaimColumns.state,
        ClaimColumns.effectiveDate,
        ClaimColumns.endDate,
        ClaimColumns.claimNumber,
      ]}
      filters={[ClaimFilters.insuredNameSearch]}
      additionalPayload={{
        status: ClaimStatusFilter_ApprovedOrAttached,
      }}
      linkSharedClaimNumber
      includeExport={false}
    />
  );
}
